import { Select, SelectProps } from "antd";
import React, { useState } from "react";


/**
 * **Expands on Antd <Select/> component** 
 * 
 * Adds the following functionality:
 * - Text entered into search bar persists and does not get reset when focus is lost
 */
const SelectWrapper = (props: SelectProps & {children: React.ReactNode}) => {
    const [search, setSearch] = useState("");

    const {onSearch, ...remainingProps} = props;

    const onSearchWrapper = (value: string) => {
        setSearch(value);
        onSearch && onSearch(value);
    }

    return <Select 
        onSearch={onSearchWrapper} 
        searchValue={search}
        {...remainingProps}
        >
        {props.children}
    </Select>
}

export default SelectWrapper;